import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "wn-modal",
  role: "dialog",
  "aria-modal": "true",
  "aria-labelledby": "wn-title"
}
const _hoisted_2 = { class: "wn-header" }
const _hoisted_3 = { class: "wn-header-left" }
const _hoisted_4 = { class: "wn-subtitle" }
const _hoisted_5 = { class: "wn-body" }
const _hoisted_6 = { class: "wn-list" }
const _hoisted_7 = { class: "wn-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: "wn-overlay",
      onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"]))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "wn-star" }, [
              _createElementVNode("svg", {
                width: "20",
                height: "20",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                _createElementVNode("polygon", { points: "12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" })
              ])
            ], -1)),
            _createElementVNode("div", null, [
              _cache[3] || (_cache[3] = _createElementVNode("h2", {
                id: "wn-title",
                class: "wn-title"
              }, "O que há de novo", -1)),
              _createElementVNode("p", _hoisted_4, "Versão " + _toDisplayString(_ctx.entry.version) + " · " + _toDisplayString(_ctx.entry.date), 1)
            ])
          ]),
          _createElementVNode("button", {
            class: "wn-close",
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
            "aria-label": "Fechar"
          }, [...(_cache[5] || (_cache[5] = [
            _createElementVNode("svg", {
              width: "16",
              height: "16",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("line", {
                x1: "18",
                y1: "6",
                x2: "6",
                y2: "18"
              }),
              _createElementVNode("line", {
                x1: "6",
                y1: "6",
                x2: "18",
                y2: "18"
              })
            ], -1)
          ]))])
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entry.sections, (section) => {
            return (_openBlock(), _createElementBlock("div", {
              key: section.title,
              class: "wn-section"
            }, [
              _createElementVNode("h3", {
                class: _normalizeClass(["wn-section-title", `wn-section-title--${section.title.toLowerCase()}`])
              }, _toDisplayString(section.title), 3),
              _createElementVNode("ul", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.items, (item) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: item,
                    class: "wn-item"
                  }, [
                    _cache[6] || (_cache[6] = _createElementVNode("span", { class: "wn-dot" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(item), 1)
                  ]))
                }), 128))
              ])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            class: "wn-btn",
            type: "button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
          }, "Entendido")
        ])
      ])
    ])
  ]))
}